import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { AddDigitalPropertyComponent } from './add-digital-property/add-digital-property.component';
import { DigitalPropertyFormDetailsComponent } from './digital-property-form-details/digital-property-form-details.component';
import { AddSingleDigitalPropertyComponent } from './add-digital-property/add-single-digital-property/add-single-digital-property.component';
import { AddMultipleDigitalPropertyComponent } from './add-digital-property/add-multiple-digital-property/add-multiple-digital-property.component';
import { ScanningAgentSwitchComponent } from '../../../components/scanning-agent-switch/scanning-agent-switch.component';
import { ConfidentialScanningSwitchComponent } from '../../../components/confidential-scanning-switch/confidential-scanning-switch.component';

@NgModule({
  imports: [CommonModule, SharedModule, ScanningAgentSwitchComponent, ConfidentialScanningSwitchComponent],
  declarations: [
    AddDigitalPropertyComponent,
    AddSingleDigitalPropertyComponent,
    AddMultipleDigitalPropertyComponent,
    DigitalPropertyFormDetailsComponent,
  ],
  exports: [
    AddDigitalPropertyComponent,
    AddSingleDigitalPropertyComponent,
    AddMultipleDigitalPropertyComponent,
    DigitalPropertyFormDetailsComponent,
    ConfidentialScanningSwitchComponent,
  ],
})
export class PortfolioSharedModule {}
